import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import InfoTabMD from "../../../../docs/InfoTab.md";
import TabWrapper from "../../../../components/TabWrapper";
import CodeBlock from "src/components/CodeBlock";
import * as remarkGfm from "remark-gfm";

interface InfoTabProps {}

const InfoTab: React.FC<InfoTabProps> = ({}) => {
  const [markdown, setMarkdown] = useState("");

  useEffect(() => {
    fetch(InfoTabMD)
      .then((res) => res.text())
      .then((text) => setMarkdown(text));
  }, []);

  useEffect(() => {
    console.log('Info tab rendered');
  });

  return (
    <TabWrapper>
      <ReactMarkdown
        className="prose dark:prose-dark"
        children={markdown}
        components={{
          code({ node, inline, className, children, ...props }) {
            const match = /language-(\w+)/.exec(className || "");
            return !inline && match ? (
              <CodeBlock
                language={match[1]}
                value={String(children).replace(/\n$/, "")}
                {...props}
              />
            ) : (
              <code className={className} {...props}>
                {children}
              </code>
            );
          },
        }}
        remarkPlugins={[remarkGfm as any]}
      />
    </TabWrapper>
  );
};

export default React.memo(InfoTab);
